import axios from 'axios';

export const BASE_URL = 'https://api-gateway.abhayagencies.com';
// export const BASE_URL = 'http://localhost:5003';
export const API_URL = `${BASE_URL}/v1`;

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add a request interceptor to include the auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token') || sessionStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);


// Add a response interceptor to handle token expiration and auto-sort master data
api.interceptors.response.use(
  (response) => {
    // Automatically sort arrays that have an 'order' property
    const sortArray = (arr) => {
      if (Array.isArray(arr) && arr.length > 0 && typeof arr[0] === 'object' && arr[0] !== null && 'order' in arr[0]) {
        arr.sort((a, b) => {
          let orderA = parseInt(a.order);
          if (isNaN(orderA)) orderA = 9999;
          
          let orderB = parseInt(b.order);
          if (isNaN(orderB)) orderB = 9999;
          
          return orderA - orderB;
        });
      }
    };

    if (response.data) {
      if (Array.isArray(response.data)) {
        sortArray(response.data);
      } else if (response.data.data && Array.isArray(response.data.data)) {
        sortArray(response.data.data);
      }
    }
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401 && !error.config.url.includes('/auth/login')) {
      // Token is invalid or expired
      localStorage.removeItem('token');
      sessionStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
